<template>
	<vxe-modal v-model="modal" title="拆包时效统计" width="1200" height="600" @show="show" :loading="loading" show-footer>
		<template #default>
			<vxe-toolbar>
				<template #buttons>
					<vxe-button @click="paymentsummaryExport">导出</vxe-button>
				</template>
			</vxe-toolbar>

			<vxe-table ref="paymentsummary" footer-cell-class-name="footerCellColor" :show-footer="true"
				:footer-method="accountFooterMethod" border show-overflow height="400" :data="tableData">
				<vxe-column type="seq" width="60"></vxe-column>
				<vxe-column field="warehouse" title="仓库"></vxe-column>
				<vxe-column field="staffname" title="拆包员"></vxe-column>
				<vxe-column sortable field="ordernum" title="单据数量"></vxe-column>
				<vxe-column sortable field="avgtime" title="平均拆包时间(小时)"></vxe-column>
			</vxe-table>


		</template>
		<template #footer>
			<vxe-button status="" content="返回" @click="cancel"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			row: {
				default: () => {
					return null
				}
			},
			time: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				sourcedata:[],
				modal: false,
				loading: false,
				tableData: [],
				form: {
					mkcode: '',
					checkstaffid: null,
				},
			}
		},
		watch: {
			selectTab(){
				this.init()
			}
		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			init() {
				this.loading = true
				this.tableData = []
				this.$api.unpackingtime.getSummary({
					time: this.time
				}).then((res) => {
					this.loading = false
					this.sourcedata = res
					let tableData = []
					let groupedData = this.$Lodash.groupBy(res, 'storage_name')
					for(let i in groupedData){
						groupedData[i] = this.$Lodash.groupBy(groupedData[i], 'staffname')
					}
					for (let i in groupedData) {
						for (let j in groupedData[i]) {
							let obj = {}
							obj.warehouse = i
							obj.staffname = j
							obj.ordernum = groupedData[i][j].length
							obj.avgtime = this.$Lodash.sumBy(groupedData[i][j], item => parseFloat(item.days_difference))/groupedData[i][j].length
							obj.avgtime = obj.avgtime.toFixed(2)
							tableData.push(obj)
						}
					}
					this.tableData  = tableData
					console.log(tableData)
				
				},()=>{
					this.loading = false
				})
			},

			cancel() {
				this.modal = false
			},
			hide() {
				this.$emit('hide')
			},
			show() {
				this.init()
			},
			modalShow() {
				this.modal = true
			},
			paymentsummaryExport() {
				this.$refs.paymentsummary.exportData({
					type: 'xlsx'
				})
			},
			accountFooterMethod({
				data
			}) {
				let ordernum = 0
				let avgtime = this.$Lodash.sumBy(this.sourcedata, item => parseFloat(item.days_difference))/this.sourcedata.length
				data.forEach((item) => {
					ordernum += item.ordernum ? parseFloat(item.ordernum) : 0
				})
				return [
					['合计', '', '', ordernum, avgtime.toFixed(2)]
				]
			}
		},
		components: {

		}
	}
</script>